import React from "react"

export const PrinterIcon = ({
  size = 1,
  color = "#034055",
  stroke_width = "2.5",
}) => {
  return (
    <svg
      style={{ pointerEvents: "none" }}
      width={size * 26}
      height={size * 24}
      viewBox="0 0 26 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke={color}
        strokeWidth={stroke_width}
        fill="none"
        fillRule="evenodd"
      >
        <path d="M7 19H2V8h22v11h-5" />
        <path d="M8.25 14.25h9.5v8.5h-9.5zM5.25 1.25h15.5v6.5H5.25z" />
      </g>
    </svg>
  )
}
